import {
  createContext,
  type ReactNode,
  useEffect,
  useMemo,
  useState,
  startTransition,
} from 'react';
import Cookie from 'js-cookie';

export const COOKIE_TIDELIFT_USER = 'TideliftUser';

type GeneralContextType = {
  internalLinks: InternalLinks;
  modalDefinitions: ModalsV2PerLanguage;
  isInformationStripeVisible: boolean;
  isTideliftUser: boolean;
  setIsInformationStripeVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

const defaultContextValue: GeneralContextType = {
  internalLinks: {},
  modalDefinitions: {},
  isInformationStripeVisible: true,
  isTideliftUser: false,
  setIsInformationStripeVisible: () => null,
};

export const GeneralContext = createContext<GeneralContextType>(defaultContextValue);

interface Props {
  children: ReactNode;
  internalLinks?: InternalLinks;
  modalDefinitions?: ModalsV2PerLanguage;
}

export const GeneralContextProvider = ({
  children,
  internalLinks = {},
  modalDefinitions = {},
}: Props) => {
  const [isInformationStripeVisible, setIsInformationStripeVisible] = useState(true);
  const [isTideliftUser, setIsTideliftUser] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('tidelift') === 'tidelift-redirect') {
      Cookie.set(COOKIE_TIDELIFT_USER, 'true');
      setIsTideliftUser(true);
    } else if (Cookie.get(COOKIE_TIDELIFT_USER) === 'true') {
      startTransition(() => {
        setIsTideliftUser(true);
      });
    }
  }, []);

  const value = useMemo(
    () => ({
      internalLinks,
      isInformationStripeVisible,
      isTideliftUser,
      modalDefinitions,
      setIsInformationStripeVisible,
    }),
    [
      internalLinks,
      isInformationStripeVisible,
      isTideliftUser,
      modalDefinitions,
      setIsInformationStripeVisible,
    ]
  );

  return <GeneralContext.Provider value={value}>{children}</GeneralContext.Provider>;
};

export default GeneralContext;
